"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDetector = void 0;

var _utils = require("./utils");

var _constants = require("./constants");

// let hasLocalStorageSupport;
// try {
//   hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
//   const testKey = 'i18next.translate.boo';
//   window.localStorage.setItem(testKey, 'foo');
//   window.localStorage.removeItem(testKey);
// } catch (e) {
//   hasLocalStorageSupport = false;
// }
// parts were taken from:
// https://github.com/i18next/i18next-browser-languageDetector/blob/master/src/browserLookups/localStorage.js
// https://github.com/i18next/i18next-browser-languageDetector/blob/master/src/browserLookups/navigator.js
// https://github.com/i18next/i18next/blob/master/src/LanguageUtils.js
var getDetector = function getDetector(providedLanguage) {
  return {
    name: _constants.DETECTOR_NAME,
    lookup: function lookup() {
      var found = []; // localStorage part
      // if (options.lookupLocalStorage && hasLocalStorageSupport) {
      //   const lng = window.localStorage.getItem(options.lookupLocalStorage);
      //   if (lng) {
      //     found.push(languageMapper(lng));
      //   }
      // }
      // navigator part

      if (typeof navigator !== 'undefined') {
        if (navigator.languages) {
          // chrome only; not an array, so can't use .push.apply instead of iterating
          for (var i = 0; i < navigator.languages.length; i += 1) {
            found.push((0, _utils.languageMapper)(navigator.languages[i]));
          }
        }

        if (navigator.userLanguage) {
          found.push((0, _utils.languageMapper)(navigator.userLanguage));
        }

        if (navigator.language) {
          found.push((0, _utils.languageMapper)(navigator.language));
        }
      } // provided part


      found.push(providedLanguage);
      return found.length > 0 ? found : undefined;
    } // cacheUserLanguage(lng, options) {
    //   if (options.lookupLocalStorage && hasLocalStorageSupport) {
    //     window.localStorage.setItem(options.lookupLocalStorage, lng);
    //   }
    // },

  };
};

exports.getDetector = getDetector;